<template>
    <div>
        <navigation-wrapper v-if="isLoggedIn" @logout="handleLogoutEvent">
            <breadcrumb-collection slot="breadcrumb" />
            <router-view />
        </navigation-wrapper>
        <router-view v-else @login="handleLoginEvent" />
        <template v-if="isLoggedIn">
            <floating-chatroom-access />
        </template>
    </div>
</template>

<script>
import NavigationWrapper from 'organels/NavigationWrapper.vue';
import BreadcrumbCollection from 'organels/breadcrumb-collection';
import FloatingChatroomAccess from './components/organels/floating-chatroom/FloatingChatroomAccess.vue';
import AdminMixin from 'mixins/admin';
import {
    closeNotificationEventSource,
    openNotificationEventSource,
} from 'libs/notificationEventSource';
import { getAdminRealtimeNotificationTopics } from 'libs/realtimeNotificationTopics';
import { ADMIN_NOTIFICATION_EVENT } from 'mixins/adminNotificationMixin';

export default {
    name: 'App',
    mixins: [AdminMixin],
    data: () => ({
        isLoggedIn: false
    }),
    components: {
        NavigationWrapper,
        BreadcrumbCollection,
        FloatingChatroomAccess
    },
    mounted() {
        this.isLoggedIn = this._alreadyLogin();
        this.syncRealtimeConnection();
    },
    beforeDestroy() {
        closeNotificationEventSource();
    },
    watch: {
        isLoggedIn() {
            this.syncRealtimeConnection();
        }
    },
    methods: {
        syncRealtimeConnection() {
            if (!this.isLoggedIn || !this._alreadyLogin()) {
                closeNotificationEventSource();
                return;
            }

            openNotificationEventSource({
                userId: 'admin',
                topics: getAdminRealtimeNotificationTopics(),
                onSignal: (event) => {
                    this.$root.$emit(ADMIN_NOTIFICATION_EVENT, event);
                }
            });
        },
        handleLoginEvent() {
            this.isLoggedIn = true;
        },
        handleLogoutEvent() {
            closeNotificationEventSource();
            this.isLoggedIn = false;
        }
    }
};
</script>
